import React from "react"

import CircularProgress from "@mui/material/CircularProgress"
import {makeStyles} from "tss-react/mui"
const useStyles = makeStyles()((theme) => ({
	progress: {
		margin: theme.spacing(2),
	},
}))

function CircularIndeterminate() {
	const {classes} = useStyles()

	return (
		<div>
			<CircularProgress className={classes.progress} />
		</div>
	)
}

export default CircularIndeterminate
